import { fetch } from './fetch';
import { urls } from '@zapier/identity-utils';
import { removeStoredAuthType } from '../hooks';

/**
 * Log the user out
 */
export function logout() {
  removeStoredAuthType();

  return fetch(urls.LOGOUT_API_URL, {
    headers: {
      Accept: 'application/json',
    },
  });
}
